import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import { trackPromotionClick } from 'helpers'

export class HeroAlt extends React.PureComponent<HeroAlt.Props, HeroAlt.State> {
  public static contextType = ShopifyNext.Context;
  public static sectionId = 'heroalt';

  public componentDidMount =() => {
    // document.querySelector('.body-wrapper').classList.remove('pt-5-6', 'pt-9-6', 'md:pt-11-3')
  }

  public render(): JSX.Element {
    const { settings, blocks } = this.props.section
    return (
      <div>
        <section className={'dynamic-heroalt'}>
          <div className={'w-full relative max-w-container mx-auto'}>
            <div className={'flex flex-col md:flex-row'}>
              {
                blocks ?
                  blocks.map((block: any, i: number) => this.buildItem(block, i)) :
                  this.placeholder()
              }
            </div>
          </div>
        </section>
      </div>
    )
  }

  private placeholder = (): JSX.Element[] => {
    const placeholders = Array.from({ length: this.props.section.block_size })
    return placeholders.map((_val: undefined, i: number) => {
      return (
        <div key={i} className={'w-full md:w-1/2'}>
          <div className={'relative bg-grey-100'}>
            <div className={'relative'}>
              <Snippets.Image
                alt={'placeholder loading image'}
                ratio={'2:1'}
                className={'content-placeholder absolute inset-0 hidden lg:block max-h-120'}
                src={null}
              />
              <Snippets.Image
                alt={'placeholder loading image'}
                ratio={'3:4'}
                className={'content-placeholder absolute inset-0 block lg:hidden max-h-144'}
                src={null}
              />
            </div>
          </div>
        </div>
      )

    })
  }

  private buildItem = (item: any, i: number): JSX.Element => {
    const { settings } = item
    const { image } = settings
    const mobileImage = settings.imagemobile ? settings.imagemobile : settings.image

    return (
      <div key={i} className={'w-full md:w-1/2 group'}>
        <div className={'relative'}>
          <div className={'relative overflow-hidden'}>
            <Snippets.Image
              alt={settings.title || "Hero banner image one"}
              ratio={'16:9'}
              className={'absolute h-screen inset-0 hidden lg:block group-hover:transform-scale'}
              src={image}
              preventLazy
            />
            <Snippets.Image
              alt={settings.title || "Hero banner image two"}
              ratio={'3:4'}
              className={'absolute h-screen inset-0 block lg:hidden'}
              src={mobileImage}
              preventLazy
            />
          </div>

          {settings.linkurl && settings.linktext ? (
            <div className={`absolute inset-0 flex items-center justify-center z-10 w-full
              ${settings.colour == 'black' ? 'text-black' : 'text-white'}`}>
              <div className={'flex flex-col items-center justify-center px-1'}>
                <img src={settings.logo} alt={`${settings.title} logo`}/>
                {settings.linktext ? (
                  <Snippets.Button
                    onClick={() => trackPromotionClick(
                      [{
                        id: `${this.props.section.id}-block-${i}`,
                        name: settings.title,
                        creative: 'Alternative hero',
                        position: `${i}`
                      }],
                      settings.linkurl
                    )}
                    className={`mt-1-3 md:mt-1-8 flex items-center ${settings.color === 'black' ? 'text-black' : 'text-white'}`}
                    title={settings.linktext}
                    colour={'blank'}
                  >
                    <Snippets.Heading size={'h5'} tag={'p'}>{settings.linktext}</Snippets.Heading>
                    {settings.color === 'black' ?  <Snippets.Icon name={'chevron_right'} width={18} height={8} ariaHidden/> :  <Snippets.Icon name={'chevron_right_reverse'} width={40} ariaHidden/>}
                  </Snippets.Button>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    )
  };
}

export namespace HeroAlt {
  export interface Options extends ShopifyNext.Section<{
    fullwidth: any;
  }> {
    block_size: number;
  }
  export interface Props extends GlobalProps {
    section: HeroAlt.Options;
  }
  export interface State { }
}
